import {NEXT_PUBLIC_USE_REFRESH_TOKEN} from '../../constants/env'

export const DUES_SCHEDULED_PAYMENTS_ENABLED = 'scheduled_payments_enabled'

export const useRefreshToken = () => NEXT_PUBLIC_USE_REFRESH_TOKEN === 'ON'
